import styled from 'styled-components';

import { Star } from 'shared/icons/Star';

interface IAppRating {
  className?: string;
}

export const AppRating = ({ className }: IAppRating) => (
  <AppRating.Wrapper className={className} data-qa="app_rating">
    <AppRating.NumericalRating>4.9</AppRating.NumericalRating>
    <AppRating.StarWrapper>
      <AppRating.WhiteStar />
      <AppRating.WhiteStar />
      <AppRating.WhiteStar />
      <AppRating.WhiteStar />
      <AppRating.WhiteStar />
      <AppRating.ActiveStars rating={4.9 / 5}>
        <AppRating.StyledStar />
        <AppRating.StyledStar />
        <AppRating.StyledStar />
        <AppRating.StyledStar />
        <AppRating.StyledStar />
      </AppRating.ActiveStars>
    </AppRating.StarWrapper>
    1.8M
  </AppRating.Wrapper>
);

AppRating.Wrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 11.5px;
  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    text-align: left;
  }
`;
AppRating.NumericalRating = styled.div`
  letter-spacing: 2px;
  display: inline-block;
`;
AppRating.StarWrapper = styled.div`
  position: relative;
  display: inline-block;
  white-space: nowrap;
  margin: 0 4px 5px;
`;
AppRating.StyledStar = styled(Star)`
  width: 12px;
  height: 12px;
  path {
    fill: ${({ theme }) => theme.colors.darkGray};
  }
`;
AppRating.WhiteStar = styled(Star)`
  width: 12px;
  height: 12px;
  path {
    fill: ${({ theme }) => theme.colors.white};
  }
`;
AppRating.ActiveStars = styled.div<{
  rating: number;
}>`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: ${({ rating }) => rating * 100}%;
  overflow: hidden;
  white-space: nowrap;
`;
